import { useAxiosWrapper } from '../../services/axiosWrapper';
import { useBaseActions } from '../base.actions';
import { comandaAtom } from "./ComandaState";
import { useRecoilValue } from 'recoil';
import { authAtom } from '../usuarios/AuthState';

function useComandaActions() {
  const baseActions = useBaseActions('comandas', comandaAtom);
  const axiosWrapper = useAxiosWrapper();
  const baseUrl = `${process.env.REACT_APP_API_URL}/v1/consultores`
  const authState = useRecoilValue(authAtom);

  return {
    list: baseActions.list,
    get: baseActions.get,
    patch: baseActions.patch,
    agrupamentoStatus,
    // create: baseActions.create,
    // update: baseActions.update,
    // delete: baseActions.delete,
  };

  async function agrupamentoStatus(historico: boolean, modeloComercial: string) {
    try {
      return await axiosWrapper.get(`${baseUrl}/${authState?.id}/comandas/agrupamento/status?historico=${historico}&modeloComercial=${modeloComercial}`);
    } catch (error) {
      console.error('Erro ao buscar agrupamento de status:', error);
      throw error;
    }
  }
}

export { useComandaActions };
